import BttfAxios from '@features/utils/axios';

class MessageServiceClass {
  public getConfirmationDetails(token: string) {
    return BttfAxios.get(`/api/confirmation_requests/${token}`,
      res => Promise.resolve(res),
      err => Promise.reject(err)
    );
  }

  public checkIfInvested(investorId: number) {
    return BttfAxios.post(`/api/investors/${investorId}/not_investing`, undefined, (res) => {
      return Promise.resolve(res);
    }, (err) => {
      return Promise.reject(err);
    });
  }

  public handleConfirmation(token: string, action: 'confirmation' | 'rejection') {
    return BttfAxios.post(`/api/confirmation_requests/${token}/${action}`, undefined, (res) => {
      return Promise.resolve(res);
    }, (err) => {
      return Promise.reject(err);
    });
  }
}

const MessageService = new MessageServiceClass();

export default MessageService;
